import * as yup from 'yup';

export default yup.object().shape({
  name: yup.string().trim().max(255, 'Lungime maximă 255 caractere'),
  description: yup.string().trim().max(255, 'Lungime maximă 255 caractere')
});
